import { MODULE_ID } from '@qflow/constants'

export const moduleNameFromId = moduleTagDefinitionId => {
  if (moduleTagDefinitionId === MODULE_ID.DELIVERY) {
    return 'delivery'
  }
  return 'waste'
}
